<template>
  <main>
    <div class="container">
      <div class="main-content-box">
        <div class="top-page-divider">
          <h3 class="page-title">Terms of Service</h3>
        </div>
        <p>Version 1.0</p>
        <p>Effective Date: March 2025</p>
        <hr>

        <h5 class="mt-4 mb-4">INTRODUCTION</h5>
        <p>
          These Terms of Service (“Terms”), along with our
          <a href="https://xalor.io/privacy/">Privacy Policy</a>,
          <a href="https://xalor.io/rules/">Game Rules</a>,
          and any other referenced policies or supplemental terms, govern your access to and use of all
          Xalor products and services (collectively, “Services”).
        </p>
        <p>
          The Services are provided by Xalor (“Xalor,” “we,” “our,” “us”),
        </p>
        <p>
          Please read these Terms carefully. By creating an account, downloading, installing, accessing, or using
          any Xalor Service, you agree to be bound by these Terms. If you do not agree, do not create
          an account or use our Services. If you have already done so and no longer agree, you must stop using the
          Services and uninstall any related software immediately.
        </p>
        <p>
          Some Services may also be subject to third-party platform terms (for example, Google Play Store).
          These Terms apply in addition to any such third-party terms.
        </p>
        <p>
          Keep a copy of these Terms for your records. We may update them from time to time, and your continued
          use of the Services will mean you accept those updates.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">CHANGES TO THESE TERMS</h5>
        <p>
          We may revise these Terms when necessary, including but not limited to: (a) legal or regulatory changes;
          (b) security or compliance requirements; (c) technical updates to the Services; or (d) to improve clarity
          and consistency. Updated Terms will take effect immediately once posted. Continued use of the Services
          after changes are published means you accept the revised Terms.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">ACCOUNT TERMINATION</h5>
        <p><b>3.1. Account Suspension or Termination</b></p>
        <p>
          <b>You.</b> You may close or suspend your account at any time by contacting us at
          <a href="mailto:support@xalor.io">support@xalor.io</a>.
        </p>
        <p>
          <b>Us.</b> We may suspend or terminate your account, without prior notice, if we reasonably determine that:
        </p>
        <ul class="bulletpoints">
          <li>You have violated these Terms or the Game Rules.</li>
          <li>Suspension is necessary to protect our community, Services, or third-party rights.</li>
          <li>We stop offering a Service or feature (with prior notice where practical).</li>
          <li>You failed to pay fees owed, or we must refund a payment due to unauthorized use.</li>
          <li>You engaged in unauthorized use of someone else’s payment information.</li>
        </ul>

        <hr>
        <h5 class="mt-4 mb-4">LICENSE TO USE SERVICES</h5>
        <p>
          We grant you a limited, non-exclusive, non-transferable, revocable license to use the Services and any
          virtual content solely for personal, non-commercial, entertainment purposes, subject to compliance with these Terms.
          This license ends immediately if your account is terminated. Unless expressly permitted by us in writing, you may not:
        </p>
        <ul class="bulletpoints">
          <li>Sell, copy, transfer, or distribute our Services or content;</li>
          <li>Reverse engineer, decompile, or derive source code;</li>
          <li>Publish, assign, sublicense, or otherwise exploit our intellectual property.</li>
        </ul>

        <hr>
        <h5 class="mt-4 mb-4">VIRTUAL GOODS, CURRENCY, AND PURCHASES</h5>
        <p>
          Our Services may offer access to digital items such as skins, emotes, weapons, or in-game currency
          (“Virtual Content”). Virtual Content may be obtained through purchase, gameplay, or gifts from other players.
        </p>
        <p>
          You do not “own” Virtual Content. What you acquire is a limited, revocable license to use that Virtual Content
          within the Services. Virtual Content has no real-world value, cannot be exchanged for money, and is non-transferable
          unless explicitly enabled by the Services.
        </p>
        <p>
          We reserve the right to modify, remove, or re-balance Virtual Content at any time in order to improve gameplay,
          meet legal requirements, or maintain fairness. If we retire certain items, we may replace them with alternatives.
          Virtual Content may be lost if your account is terminated or if technical or policy changes require its removal.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">GAME RULES</h5>
        <p>
          You must follow all current rules, codes of conduct, and gameplay guidelines associated with our Services.
          Violations may result in suspension, termination, or other enforcement actions. Current game rules are available
          <a href="https://xalor.io/support/game-rules/">here</a>.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">REFUND POLICY</h5>
        <p>
          Refund requests will be reviewed on a case-by-case basis. Unless required by law, refunds are not available
          for in-game purchases, currency, or product pins in the following cases:
        </p>
        <ul class="bulletpoints">
          <li>Losses due to in-game scams (although we may assist with account recovery).</li>
          <li>Suspension or termination of your account for violations of these Terms or Game Rules.</li>
          <li>Use of unauthorized software to access the Services.</li>
          <li>Voluntary cancellation of your account.</li>
        </ul>
        <p>
          If you believe you are eligible for a refund, contact our support team
          <a href="https://xalor.io/account/tickets/">here</a>. Refunds are granted at our sole discretion,
          unless otherwise required by law.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">THIRD-PARTY SERVICES</h5>
        <p>
          Some Services may link to or incorporate third-party sites, tools, or payment providers.
          We are not responsible for third-party products, services, or technologies and provide no warranties
          regarding their functionality, safety, or availability. Your use of third-party services is at your own risk.
        </p>
        <p>
          We do not guarantee that any suggested third-party tools are secure, reliable, or virus-free.
          We are not liable for damage, disruption, or data loss caused by third-party technologies.
        </p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created() {
    document.title = 'Terms of Service - Xalor'
  }
}
</script>
